import { render, staticRenderFns } from "./PrintingQueueModal.vue?vue&type=template&id=ef2a5442&scoped=true&"
import script from "./PrintingQueueModal.vue?vue&type=script&lang=js&"
export * from "./PrintingQueueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a5442",
  null
  
)

export default component.exports